/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { StructuredText } from 'react-datocms'
import type { StructuredTextFieldsFragment } from 'types/dato'
import {
	Accordion as MDSAccordion,
	AccordionContent,
	AccordionItem,
	AccordionToggle,
} from '@hashicorp/mds-react/components'
import Anchor from 'components/materia/anchor'
import { useState, useEffect } from 'react'

type BlocksType = StructuredTextFieldsFragment['body']['blocks'][number]
type AccordionType = Extract<BlocksType, { __typename: 'StAccordionRecord' }>

export default function Accordion({ items, updateUrl }: AccordionType) {
	const [activeAnchor, setActiveAnchor] = useState<string | null>(null)

	useEffect(() => {
		if (typeof window === 'undefined') return
		const hash = window.location.hash?.slice(1)
		if (hash) {
			setActiveAnchor(hash)
		}
	}, [])

	return (
		<MDSAccordion>
			{items.map(({ heading, content, anchor, isOpen }) => {
				const shouldOpen = anchor === activeAnchor || isOpen
				return (
					<AccordionItem
						id={anchor ? anchor : undefined}
						key={heading}
						isOpen={shouldOpen}
					>
						<Anchor anchorId={anchor} />
						<AccordionToggle anchorId={anchor} updateUrl={updateUrl}>
							{heading}
						</AccordionToggle>
						<AccordionContent>
							<StructuredText data={content} />
						</AccordionContent>
					</AccordionItem>
				)
			})}
		</MDSAccordion>
	)
}
